import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import zhHant from 'vuetify/lib/locale/zh-Hant'
import preset from './default-preset/preset'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { zhHant },
    current: 'zhHant',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
